module.exports = __webpack_public_path__ + "static/media/refer-rewards.86738d5f.png";